class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
		this.classList.remove('open');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerMain = this.closest('.header');
    this.isCollectionTypeMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu--collection_type');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.closeTimeout = null;
    // this.onDesktopSummaryClick = this.onDesktopSummaryClick.bind(this);
    this.onMenuMouseEnter = this.onMenuMouseEnter.bind(this);
    this.onMenuMouseLeave = this.onMenuMouseLeave.bind(this);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.toggleClass.bind(this));

    if (this.isCollectionTypeMegaMenu) {
      // this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onDesktopSummaryClick);
      this.addEventListener('mouseenter', this.onMenuMouseEnter);
      this.addEventListener('mouseleave', this.onMenuMouseLeave);
    }
  }

	toggleClass() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.header.classList.add('open');
      this.headerMain.classList.add('open');
      this.mainDetailsToggle.classList.add('open');
      if (this.isCollectionTypeMegaMenu) {
        document.body.classList.add('collection-type-mega-open');
      }
    } else {
      this.header.classList.remove('open');
      this.headerMain.classList.remove('open');
      this.mainDetailsToggle.classList.remove('open');
      if (this.isCollectionTypeMegaMenu) {
        document.body.classList.remove('collection-type-mega-open');
      }
    }
	}

  onToggle() {
    if (!this.header) return;
  
    this.header.preventHide = this.mainDetailsToggle.open;
  
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }


  // onDesktopSummaryClick(event) {
  //   if (!this.desktopMediaQuery.matches) return;
  //   // event.preventDefault();
  //   // event.stopPropagation();

  //   const summary = this.mainDetailsToggle.querySelector('summary');
  //   const isOpen = this.mainDetailsToggle.hasAttribute('open');

  //   if (isOpen) {
  //     this.close();
  //     return;
  //   }

  //   if (this.closeTimeout) {
  //     clearTimeout(this.closeTimeout);
  //     this.closeTimeout = null;
  //   }

  //   this.mainDetailsToggle.setAttribute('open', '');
  //   summary.setAttribute('aria-expanded', true);
  // }

  onMenuMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMenuMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }
}

customElements.define('header-menu', HeaderMenu);


window.addEventListener('scroll', updateHeaderPosition);
window.addEventListener('resize', updateHeaderPosition);

function updateHeaderPosition() {
  const header = document.querySelector('header');
  if (!header) return;

  document.documentElement.style.setProperty(
    '--header-bottom-position-desktop',
    `${Math.floor(header.getBoundingClientRect().bottom)}px`
  );
}
 